import React from 'react';
import { useBrokenFlowModal } from '@edreamsodigeo/frontend-core';
import { RunTimeModalError } from '@/components/FunnelErrors/errors/RunTimeModalError';
import { withPriceFreezeContext } from '@/withPriceFreezeContext';

const BrokenFlowModal = (props) => {
  const brokenFlowProps = useBrokenFlowModal();
  return <RunTimeModalError {...props} {...brokenFlowProps} />;
};
export const BrokenFlowFlights = withPriceFreezeContext(BrokenFlowModal);
